import { render } from "./IntroductionView.vue?vue&type=template&id=4ae92a06&lang=pug"
import script from "./IntroductionView.vue?vue&type=script&lang=js"
export * from "./IntroductionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__